module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAMRJREFUOI3NkzsSgzAMRFdMDqQQeszJGJ8spidGJ0IpbGYI/pCCgq2wVzxLLAbuJgIA5nYEkUlcJSsyu22ZrVN1It4+Ao6MLJ9h7zN3BqQjc9sDzQSsPdBMssz2p+75egOIoIxiJy50oaMsfijVAkBTM7duT2tKIObOMHdZQMkrjLb28cEdISUvCxLxNr8fvlvOS0BbWgCQJhnjj5FXQbVT48vZbs9T+1OXgcJoqi7+oalUHYhM1b9StF8UL29Jh0t9L30BUh9XoBi/xX8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliZhuanye.png
// module id = eKGY
// module chunks = 1